module.exports = (__webpack_require__("2pFd"))("SHB2");